import { Assets } from 'pixi.js';

import { EnvironmentTypes } from '../../enums';
import { env } from '../../environment';

export const PixiAssets = Assets;

// Assets.init() must be called only once. Multiple calls on Android Chrome can
// reset the basePath mid-load and silently break font registration.
let assetsInitialized = false;

async function ensureAssetsInit(pixiAssets: typeof Assets): Promise<void> {
  if (assetsInitialized) return;
  assetsInitialized = true;

  const isDev = env.type === EnvironmentTypes.Development;
  const basePath = isDev
    ? `${window.location.origin}/`
    : `${window.location.origin}/launcher/`;

  await pixiAssets.init({
    // Keep absolute base path with trailing slash to avoid route-relative resolution.
    basePath,
  });
}

async function allResourceDynamicLoader(
  pixiAssets: typeof Assets,
  resolve: Function,
  reject: Function,
  loadedResourceKey: string[],
) {
  await ensureAssetsInit(pixiAssets);
  pixiAssets
    .load(loadedResourceKey)
    .then(async (res) => {
      // Android Chrome requires document.fonts.ready to be awaited after a
      // FontFace is added via the FontFace API (which Pixi uses internally).
      // iOS Safari picks up new fonts immediately; Android does not.
      if (document?.fonts?.ready) {
        await document.fonts.ready;
      }
      resolve(res);
    })
    .catch((err) => {
      console.error(err);
      console.error(`❌ Failed to load resources: ${loadedResourceKey}`);
      reject();
    });
};

export const loadResources = async (resources: any[]) => {
  await ensureAssetsInit(PixiAssets);

  const resourceNames: string[] = [];

  resources.forEach((item) => {
    PixiAssets.add(item.name, item.path, item.config);
    resourceNames.push(item.name);
  });

  return new Promise((resolve, reject) => allResourceDynamicLoader(PixiAssets, resolve, reject, resourceNames));
};
